module.exports = "<!-- <gods-view-map></gods-view-map> -->\n<main-sidenav sections=\"$ctrl.sections\">\n  <main-sidenav></main-sidenav>\n</main-sidenav>\n";


//////////////////
// WEBPACK FOOTER
// ./src/pages/fleet/fleet.html
// module id = 1314
// module chunks = 0